import * as React from 'react';
import classNames from 'classnames';

import { Link } from '../Link';
import { getLinksList } from './utils/getLinksList';

import * as styles from './LinksBlock.css';
import * as gridStyles from '../../utils/grid.css';

interface ILinksBlockProps {
  withAdditionalLinks: boolean;
  onLinkClick(event: React.MouseEvent<HTMLAnchorElement>, name: string): void;
}

type TClearEffectList = { (): void }[];

export const LinksBlock: React.FC<ILinksBlockProps> = ({ withAdditionalLinks, onLinkClick }) => {
  const links = React.useMemo(() => getLinksList({ withAdditionalLinks }), [withAdditionalLinks]);

  React.useEffect(() => {
    const clearEffectList: TClearEffectList = links.reduce((acc, { effectHandler }) => {
      if (effectHandler) {
        acc.push(effectHandler());
      }

      return acc;
    }, [] as TClearEffectList);

    return () => {
      clearEffectList.forEach(clearEffect => clearEffect());
    };
  }, [links]);

  const handleOnClick = React.useCallback(
    ({ event, name, onClick }: { event: React.MouseEvent<HTMLAnchorElement>; name: string; onClick?: () => void }) => {
      if (onClick) {
        event.preventDefault();
        onClick();
      }

      onLinkClick(event, name);
    },
    [onLinkClick],
  );

  return (
    <div className={classNames(styles['c-footer-links-container'], gridStyles['cg-col-24'])}>
      <ul className={styles['c-footer-links']}>
        {links.map(({ href, text, name, theme, onClick }, index) => (
          <li key={`links_block_${index}`} className={styles['c-footer-links-item']}>
            <Link href={href} theme={theme} onClick={event => handleOnClick({ event, name, onClick })}>
              {text}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};
